<div class="modal-header">
  <h3 class="modal-title">{{ config?.title }}</h3>
</div>
<div class="modal-body">{{ config?.body }}</div>
<div class="modal-footer">
  <button class="btn btn-primary" (click)="accept()">{{ config?.accept }}</button
  ><button class="btn btn-default" (click)="reject()">{{ config?.reject }}</button>
</div>
